import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const NavHeader: React.FC = () => {
  const { user } = useAuth();

  return React.createElement(
    Box,
    { sx: { p: 2, backgroundColor: '#B2140F', borderBottom: '1px solid rgba(0, 0, 0, 0.1)' } },
    React.createElement(
      Box,
      { sx: { display: 'flex', alignItems: 'center', gap: 2 } },
      React.createElement('img', { src: '/assets/se_logo_klein.jpg', alt: 'SE Logo', style: { height: 72 } }),
      React.createElement(
        Box,
        { sx: { flex: 1 } },
        React.createElement(Typography, { variant: 'subtitle2', sx: { color: '#fff' } }, user?.email ?? ''),
        React.createElement(Typography, { variant: 'caption', sx: { color: 'rgba(255, 255, 255, 0.8)' } }, 'by A.K.')
      )
    )
  );
};

export default NavHeader;
